import React from 'react';
import toast from 'react-hot-toast';
import Tippy from '@tippyjs/react';
import styles from './CopyToClipboard.module.css';

interface CopyToClipboardProps {
  position: 'default' | 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  codeString: string;
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ position, codeString }) => {

  const copyToClipboard = async (e: any, text: string) => {
    try {
      e.stopPropagation();
      await navigator.clipboard.writeText(text);
      toast.success('Copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy!', err);
      toast.error('Something went wrong!');
    }
  };

  return (
    <Tippy content="Copy to clipboard">
      <button
        className={`${styles.copyButton} ${styles[position]}`}
        onClick={(e) => copyToClipboard(e, codeString)}
      >
        <img src='/assets/imgs/copy_white.svg' alt='copy_to_clipboard' />
      </button>
    </Tippy>
  );
};

export default CopyToClipboard;
